function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require("react");

var styled = require("styled-components").default;

var Icon = require("@patternplate/component-icon").Icon;

var StyledSearchField = styled.label.withConfig({
  displayName: "search-field__StyledSearchField"
})(["display:flex;align-items:center;height:60px;padding:10px 15px;"]);
var StyledIcon = styled(Icon).withConfig({
  displayName: "search-field__StyledIcon"
})(["flex-grow:0;flex-shrink:0;fill:", ";"], function (props) {
  return props.theme.colors.color;
});
var StyledInput = styled.input.withConfig({
  displayName: "search-field__StyledInput"
})(["position:relative;z-index:2;width:100%;border:0;border-radius:0;background:transparent;font-size:16px;color:", ";padding:0;appearance:none;border-radius:0;border:none;:focus{outline:none;}"], function (props) {
  return props.theme.colors.color;
});
var StyledInputContainer = styled.div.withConfig({
  displayName: "search-field__StyledInputContainer"
})(["position:relative;display:flex;align-items:center;flex-grow:1;flex-shrink:0;margin-left:10px;"]);
var StyledInputSuggestion = styled(function (p) {
  return React.createElement(StyledInput, _extends({}, p, {
    readOnly: true
  }));
}).withConfig({
  displayName: "search-field__StyledInputSuggestion"
})(["position:absolute;z-index:1;top:0;left:0;opacity:0.3;"]);

var SearchField =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SearchField, _React$Component);

  function SearchField() {
    var _this;

    _classCallCheck(this, SearchField);

    _this = _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).call(this));
    _this.saveRef = _this.saveRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchField, [{
    key: "saveRef",
    value: function saveRef(ref) {
      this.ref = ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus && this.ref) {
        var length = this.props.value.length;
        this.ref.focus();
        this.ref.setSelectionRange(length, length);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return React.createElement(StyledSearchField, null, React.createElement(StyledIcon, {
        symbol: "search"
      }), React.createElement(StyledInputContainer, null, React.createElement(StyledInputSuggestion, {
        value: props.suggestion || ""
      }), React.createElement(StyledInput, {
        autoComplete: "off",
        autoFocus: props.autoFocus,
        name: props.name,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        onKeyDown: props.onKeyDown,
        placeholder: props.placeholder,
        title: props.title,
        type: "text",
        value: props.value,
        "data-search": props.mark,
        ref: this.saveRef
      })), props.children);
    }
  }]);

  return SearchField;
}(React.Component);

module.exports = SearchField;
//# sourceMappingURL=index.js.map